<template>
  <v-container class="text-center">
    <h1>Forgot your password?</h1>
    <div class="mb-10">
      Please enter the email address associated with your account and We will email you a link to reset your password.
    </div>

    <v-form
      ref="form"
      lazy-validation
      @submit="submit"
    >
      <v-text-field
        label="E-mail"
        type="email"
        required
        outlined
        :disabled="loading"
        v-model="email"
        :error-messages="emailErrors"
      ></v-text-field>

      <v-btn color="primary"
             class="w-100 sh-green mb-2"
             x-large
             :loading="loading"
             @click="submit">
        Send request
      </v-btn>

      <v-btn color="primary" x-large text class="w-100" @click="goBack">
        Back
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'Reset',

  mixins: [validationMixin],
  validations: {
    email: { required, email }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      this.invalidEmail && errors.push('Email doesn\'t exists')
      return errors
    }
  },

  data: () => ({
    loading: false,
    email: '',
    invalidEmail: false
  }),
  methods: {
    ...mapActions({
      register: 'auth/REGISTER'
    }),
    goBack () {
      this.$router.push({ name: 'auth.signin' })
    },
    submit (e) {
      e.preventDefault()

      this.invalidEmail = false
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$api.auth.resetPassword({
          email: this.email
        }).then(({ data }) => {
          this.register(this.email)
          this.$router.push({ name: 'auth.reset-password' })
        }).catch(() => {
          this.invalidEmail = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
